import React, { useEffect, useState } from 'react';
import SacredGeometry from '../components/SacredGeometry';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create mailto link with form data
    const subject = encodeURIComponent(`Demande de contact - ${formData.service || 'Général'}`);
    const body = encodeURIComponent(
      `Nom: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Téléphone: ${formData.phone}\n` +
      `Service: ${formData.service}\n\n` +
      `Message:\n${formData.message}`
    );
    
    window.location.href = `mailto:sylvaine.benklif@gmail.com?subject=${subject}&body=${body}`;
    
    setFormStatus('success');
    
    // Reset form
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
      setFormStatus('');
    }, 3000);
  };

  return (
    <div className="w-full min-h-screen pt-24 md:pt-32 pb-20">
      {/* Background */}
      <div className="fixed inset-0 bg-gradient-to-br from-purple-50 via-white to-lavender-50 -z-10">
        <SacredGeometry opacity={0.02} />
      </div>

      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-semibold text-purple-900 mb-6">
            Contact
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-400 to-lavender-500 mx-auto rounded-full mb-8"></div>
          <p className="text-gray-600 text-lg md:text-xl max-w-2xl mx-auto">
            Je serais ravie de vous accompagner dans votre cheminement. N'hésitez pas à me contacter pour toute question ou pour prendre rendez-vous.
          </p>
        </div>

        {/* Contact Card */}
        <div className="bg-white rounded-3xl shadow-soft p-10 md:p-16 animate-fade-in-up border border-purple-100">
          <div className="space-y-8">
            {/* Name */}
            <div className="text-center pb-6 border-b border-purple-100">
              <h2 className="text-3xl md:text-4xl font-serif font-semibold text-purple-900 mb-2">
                Sylvaine Ben Klif
              </h2>
              <p className="text-gray-500 italic">
                Thérapeute holistique
              </p>
            </div>

            {/* Contact Information */}
            <div className="space-y-6">
              {/* Phone */}
              <div className="flex items-center justify-center space-x-4 group">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-400 to-lavender-500 rounded-full flex items-center justify-center shadow-soft group-hover:shadow-glow transition-all duration-300">
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                </div>
                <a
                  href="tel:+41796057654"
                  className="text-xl md:text-2xl text-gray-700 hover:text-purple-700 transition-colors duration-300 font-medium"
                >
                  +41 79 605 76 54
                </a>
              </div>

              {/* Email */}
              <div className="flex items-center justify-center space-x-4 group">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-400 to-lavender-500 rounded-full flex items-center justify-center shadow-soft group-hover:shadow-glow transition-all duration-300">
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <a
                  href="mailto:info@sylvainebk.ch"
                  className="text-xl md:text-2xl text-gray-700 hover:text-purple-700 transition-colors duration-300 font-medium"
                >
                  info@sylvainebk.ch
                </a>
              </div>
            </div>

            {/* CTA Button */}
            <div className="pt-8 text-center">
              <a
                href="mailto:info@sylvainebk.ch"
                className="inline-block px-10 py-4 bg-gradient-to-r from-purple-600 to-lavender-600 text-white rounded-full hover:shadow-glow-lg transition-all duration-300 font-medium text-lg transform hover:scale-105"
              >
                Envoyer un message
              </a>
            </div>
          </div>
        </div>

        {/* Urgent Notice - Animal Perdu */}
        <div className="mt-12 animate-fade-in-up" style={{ animationDelay: '100ms' }}>
          <div className="bg-gradient-to-br from-purple-600 to-lavender-600 rounded-2xl p-8 md:p-10 border-2 border-purple-400 shadow-glow">
            <div className="flex items-start gap-4 mb-4">
              <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-full flex items-center justify-center animate-pulse">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-serif font-semibold text-white mb-3">
                  Animal perdu ? Contactez-moi en urgence
                </h3>
                <div className="space-y-3 text-purple-50 text-base md:text-lg leading-relaxed">
                  <p>
                    Si votre animal est perdu et que vous avez besoin d'aide rapidement :
                  </p>
                  <ul className="space-y-2 ml-4">
                    <li className="flex items-start">
                      <span className="mr-2">•</span>
                      <span>Appelez-moi au <a href="tel:+41796057654" className="font-semibold text-white underline hover:text-purple-100 transition-colors">+41 79 605 76 54</a></span>
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2">•</span>
                      <span>Si je ne réponds pas, envoyez-moi un <strong className="text-white">message WhatsApp</strong> ou un <strong className="text-white">SMS</strong> au même numéro</span>
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2">•</span>
                      <span>Je vous recontacterai dans les plus brefs délais</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="mt-12 animate-fade-in-up" style={{ animationDelay: '150ms' }}>
          <div className="bg-white rounded-3xl shadow-soft p-10 md:p-16 border border-purple-100">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-serif font-semibold text-purple-900 mb-4">
                Formulaire de contact
              </h2>
              <p className="text-gray-600 text-base md:text-lg">
                Remplissez ce formulaire et je vous recontacterai dans les plus brefs délais
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Name */}
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Nom complet <span className="text-purple-600">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all duration-300 outline-none"
                  placeholder="Votre nom"
                />
              </div>

              {/* Email */}
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email <span className="text-purple-600">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all duration-300 outline-none"
                  placeholder="votre.email@exemple.com"
                />
              </div>

              {/* Phone */}
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Téléphone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all duration-300 outline-none"
                  placeholder="+41 79 123 45 67"
                />
              </div>

              {/* Service */}
              <div>
                <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                  Service souhaité
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all duration-300 outline-none bg-white"
                >
                  <option value="">Sélectionnez un service</option>
                  <option value="Constellations familiales">Constellations familiales systémiques</option>
                  <option value="Communication animale">Communication animale</option>
                  <option value="Thérapie Quantique">Thérapie Quantique</option>
                  <option value="Clairconnaissance">Clairconnaissance</option>
                  <option value="Radiesthésie">Radiesthésie</option>
                  <option value="Autre">Autre / Question générale</option>
                </select>
              </div>

              {/* Message */}
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Message <span className="text-purple-600">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all duration-300 outline-none resize-none"
                  placeholder="Décrivez votre demande ou posez vos questions..."
                ></textarea>
              </div>

              {/* Submit Button */}
              <div className="text-center pt-4">
                <button
                  type="submit"
                  className="inline-block px-12 py-4 bg-gradient-to-r from-purple-600 to-lavender-600 text-white rounded-full hover:shadow-glow-lg transition-all duration-300 font-medium text-lg transform hover:scale-105 shadow-lg"
                >
                  Envoyer le message
                </button>
              </div>

              {/* Success Message */}
              {formStatus === 'success' && (
                <div className="mt-6 p-4 bg-green-50 border-2 border-green-200 rounded-xl text-center">
                  <p className="text-green-700 font-medium">
                    ✓ Votre client mail va s'ouvrir avec votre message pré-rempli !
                  </p>
                </div>
              )}
            </form>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center animate-fade-in-up" style={{ animationDelay: '200ms' }}>
          <div className="bg-gradient-to-br from-purple-50 to-lavender-50 rounded-2xl p-8 border border-purple-100">
            <h3 className="text-2xl font-serif font-semibold text-purple-900 mb-4">
              Modalités
            </h3>
            <div className="space-y-3 text-gray-600">
              <p>Séances sur rendez-vous uniquement</p>
              <p>Consultations en présentiel ou à distance</p>
              <p>Réponse sous 24-48 heures</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
